import {makeGetAuthorizationsOdonto} from 'main/factories/usecases/private/authorizations-odonto/get-authorizations-odonto';

export const getAuthorizationsOdonto = async ({signal}: {signal?: AbortSignal}) => {
	const response = await makeGetAuthorizationsOdonto().get({
		signal,
	});

	if (typeof response === 'string' || !response.content) {
		return [];
	}

	return response.content.map(item => ({
		...item,
	}));
};
